import coin from "../../../../asset/coin.png";
import cash from "../../../../asset/cash.png";
import { useTexture } from "@react-three/drei";

type Props = {
  size: [width?: number | undefined, height?: number | undefined];
  type: "coin" | "cash";
  opacity: number;
};

const moneyconfig = { coin: coin, cash: cash };

const Money = (props: Props) => {
  const { size, type, opacity } = props;

  const moneyTexture = useTexture(moneyconfig[type]);

  return (
    <>
      <planeGeometry attach={"geometry"} args={size} />
      <meshBasicMaterial
        attach={"material"}
        map={moneyTexture}
        transparent={true}
        opacity={opacity}
      />
    </>
  );
};

export default Money;
